import { isSystem, lang } from '@umu/ukit-lang';
import React, { useEffect, useState } from 'react';

import { components } from 'common';
const { If } = components;
import { footer } from '@umu/simple-footer';
const { Loading } = components;
import { getAppData } from '../../service/marketHomeService';
import { TodayCircles } from '../../components/todayCircles/todayCircles';
import { TodayCourses } from '../../components/todayCourses/todayCourses';
import { CategoryNavs } from '../../components/categoryNavs/categoryNavs';
import { MarketCarrousel } from '../../components/marketCarrousel/marketCarrousel';
import { getMarketRecommend } from 'market/@marketCommon/dataServices/getMarketRecommend';
import { CategoryRecommends } from '../../components/categoryRecommends/categoryRecommends';

import { ListType } from 'market/@marketCommon/interface/category';
import { ICarrousel, ICourseRecommend, ICircleRecommend } from 'market/@marketCommon/interface/recommend';

import './index.scss';
import { supportIntelligentCourse } from '../../../@marketCommon/utils/intelligentCourse';
import { IntelligentCourse } from '../../components/intelligentCourse/intelligentCourse';
import { isShowLearningCliclePart } from 'market/@marketCommon/services/config';

export function Index() {
    const [loading, setLoading] = useState(true);
    const [carrousel, setCarrousel] = useState<ICarrousel[]>([]);
    const [courseRecommend, setCourseRecommend] = useState<ICourseRecommend[]>([]);
    const [circleRecommend, setCircleRecommend] = useState<ICircleRecommend[]>([]);

    useEffect(() => {
        getMarketRecommend().then((res) => {
            const currentCarrousel = res.data.carrousel || [];
            const extraCarrousel = isSystem('CN')
                ? [
                      {
                          id: '',
                          bit_index: '',
                          obj_type: '',
                          obj_id: '',
                          updated_at: '',
                          updator: '',
                          url: `${location.origin}/thusem`,
                          img_url: 'https://statics-cdn-cn.umucdn.cn/statics/images/thusem.png',
                      },
                      {
                          id: '',
                          bit_index: '',
                          obj_type: '',
                          obj_id: '',
                          updated_at: '',
                          updator: '',
                          url: `${location.origin}/mercer`,
                          img_url: 'https://statics-cdn-cn.umucdn.cn/statics/images/mercer.png',
                      },
                  ]
                : [];
            setCarrousel([...currentCarrousel, ...extraCarrousel]);
            setCourseRecommend(res.data['group-today_recommend'] || []);
            setCircleRecommend(res.data['circle-today_recommend'] || []);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (!loading) {
            footer({
                platform: 'twww',
                lang: getAppData('Lang'),
                system: getAppData('SYSTEM'),
                siteHost: getAppData('siteHost'),
            });
        }
    }, [loading]);

    const render = () => {
        if (loading) {
            return <Loading className="market-home-page-loading" />;
        }
        return (
            <div className="market-home-page">
                {carrousel.length > 0 ? <MarketCarrousel data={carrousel} /> : null}
                <div className="content-body">
                    <If condition={supportIntelligentCourse}>
                        <div className="intel-part">
                            <div className="module-label">{lang('智能课单')}</div>
                            <IntelligentCourse />
                        </div>
                    </If>
                    <a href={`/market/category/all?type=${ListType.COURSE}`} className="module-label category">
                        {lang('全部分类')}
                    </a>
                    <CategoryNavs />
                    <If condition={courseRecommend.length > 0}>
                        <div className="today-course">
                            <div className="module-label">{lang('推荐课程')}</div>
                            <TodayCourses data={courseRecommend} />
                        </div>
                    </If>
                    <If condition={circleRecommend.length > 0 && isShowLearningCliclePart()}>
                        <div className="today-circle">
                            <div className="module-label">{lang('推荐学习圈')}</div>
                            <TodayCircles data={circleRecommend} />
                        </div>
                    </If>
                    <CategoryRecommends />
                </div>
                <If condition={!loading}>
                    <div className="home-end-tip">{lang('没有更多内容了')}</div>
                </If>
            </div>
        );
    };

    return render();
}
